import { addItemToCollection } from "directus/src/operations";
import { COLLECTION } from "../../constants";

export async function createDeliverable({ item }) {
  try {
    return await addItemToCollection(COLLECTION, item);
  } catch (error) {
    console.log(error);
    throw error;
  }
}
